exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px) {\n.input_boxes[data-v-69a45b88] {\n    margin-bottom: 0 !important;\n}\n}", ""]);

// exports
